import {BaseCart, CartItem, CartItemQuery} from '@eastsideco/salvo-ts';

const FREE_GIFT_THRESHOLD = 5000;

export default class Cart extends BaseCart

{
    constructor() {
        super();
    }

    get qualifiesForFreeGift() {
        return this.totalPrice > FREE_GIFT_THRESHOLD;
    }
}

export const cart = new Cart();
cart.reload().catch((event: unknown | null) => {
    if (event instanceof Error) {
        // this.$log.error(event.message);
    }
});
